import ByAccountTransactions from './ByAccountTransactions.redux';

export default ByAccountTransactions;
